import React, { useState, useEffect } from 'react';
import './PaginaSalones.scss';
import { getSalonesByLocalId } from '../../../../crud/management_api/salones';
import {Button} from 'react-bootstrap';
import LoadingSpinner from '../../../../components/common/LoadingSpinner';
import {
  convertMesaFromAPI,
  convertObjetoFromAPI,
  addMesa,
  addObjeto
} from './components/utils';
import { Mesa, Salon, Objeto } from '../types';
import { RenderSalonDropdown, RenderSalonEditModal, RenderCreateSalonModal } from './components/SalonDisplayer/components/RenderFunctions';
import SalonDisplayer from './components/SalonDisplayer/SalonDisplayer';
import { FaPen, FaPlus } from 'react-icons/fa';


const PaginaSalones: React.FC = () => {
  const [loading, setLoading] = useState(true);
  const [salones, setSalones] = useState<Salon[]>([]);
  const [selectedSalon, setSelectedSalon] = useState<Salon | undefined>(undefined);
  const [selectedItem, setSelectedItem] = useState<Mesa | Objeto | null>(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCreateModal, setShowCreateModal] = useState(false);  // State to control the creation modal
  const [scaleFactor, setScaleFactor] = useState<number>(1);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 900) {
        setIsMobile(true);
        setScaleFactor(0.4777777777777778);
      } else {
        setIsMobile(false);
        setScaleFactor(1);
      }
    };
    window.addEventListener('resize', handleResize);
    handleResize(); // chequeo inicial
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      const localId = user ? user.local_id : 0;

      getSalonesByLocalId(localId).then((response) => {
          const transformedSalones = response.data.map((salon: any) => ({
              ...salon,
              mesas: salon.mesas.map(convertMesaFromAPI),
              objetos: salon.objetos.map(convertObjetoFromAPI)
          }));
          setSalones(transformedSalones);
          setSelectedSalon(transformedSalones[0]);
          setLoading(false);
      }).catch((error) => {
          console.error('Error fetching salones: ', error);
          setLoading(false);
      });
  }, []);


  const updateSalonState = (newSalon: Salon) => {
      setSelectedSalon(newSalon);
      setSalones((prevSalones) =>
        prevSalones.map((s) =>
          s.salon_id === newSalon.salon_id ? newSalon : s
        )
      );
  };

  const handleAddMesa = () => {
      if (selectedSalon) {
          addMesa(selectedSalon, setSelectedItem, updateSalonState, salones);
      }
  };

  const handleAddObjeto = () => {
      if (selectedSalon) {
          addObjeto(selectedSalon, setSelectedItem, updateSalonState);
      }
  };

  const handleEditSalon = () => {
      setShowEditModal(true);
  };

  const handleCreateSalon = () => {
      setShowCreateModal(true);
  };

  // Modifica handleCreateSalonModalClose para crear una mesa si se acaba de crear un salón
  const handleCreateSalonModalClose = (refresh: boolean, createdSalon?: Salon) => {
    setShowCreateModal(false);
    if (refresh && createdSalon) {
      setSelectedSalon(createdSalon);
      // Quita esta línea para evitar duplicados:
      // setSalones(prev => [...prev, createdSalon]);
    }
  };

  if (loading) {
      return <LoadingSpinner text='Cargando salones' transparent={true}/>;
  }

  

  return (
    <div className="pagina-salones-container" style={{ transform: isMobile ? 'none' : `scale(1)`, transformOrigin: 'top left', overflowX: 'hidden' }}>
        <div className='mp-page-header-container'>
          <h2 className='title'>
            Salones
          </h2>
          
          {salones.length !== 0 && (
          <div className='buttons'>
            <Button  onClick={handleAddMesa}><FaPlus/> Mesa</Button>
            <Button variant='none' onClick={handleAddObjeto}><FaPlus/> Objeto</Button>
            <Button variant='none' onClick={handleEditSalon}><FaPen/> Editar salón</Button>
            <Button variant='none' onClick={handleCreateSalon}><FaPlus/> Crear salón</Button> 
          </div>
        )}
        </div>
        <RenderSalonDropdown
                salones={salones}
                selectedSalon={selectedSalon}
                onSelectSalon={setSelectedSalon}
            />
        {salones.length === 0 && (
        <div className="salones-no-salon">
            <div className='salones-no-salon-message'>
            No has creado ningun salón aún!
            </div>
            <Button className='salones-no-salon-button' onClick={handleCreateSalon}> Crear Salón </Button>
        </div>)}
        {salones.length !== 0 && 
        <SalonDisplayer
        salones={salones}
        selectedSalon={selectedSalon}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        setSelectedSalon={setSelectedSalon}
        setSalones={setSalones}
        isPedidos={false}
        actionType='configuration'
        setScaleFactor={setScaleFactor}
        scaleFactor={scaleFactor}
      />}
        
        {showEditModal && selectedSalon && (
          <RenderSalonEditModal
            salon={selectedSalon}
            onClose={() => setShowEditModal(false)}
            onSave={(updatedSalon) => {
                const updatedSalones = salones.map(s => s.salon_id === updatedSalon.salon_id ? updatedSalon : s);
                setSalones(updatedSalones);
                setSelectedSalon(updatedSalon);
                setShowEditModal(false);
            }}
            salones={salones}
            setSalones={setSalones}
            setSelectedSalon={setSelectedSalon}
          />
        )}
        {showCreateModal && (
          <RenderCreateSalonModal
            show={showCreateModal}
            handleClose={(refresh, createdSalon) => handleCreateSalonModalClose(refresh, createdSalon)}
            salones={salones}
            setSalones={setSalones}
            setSelectedSalon={setSelectedSalon}
          />
        )}
    </div>
  );
};

export default PaginaSalones;



